import React from 'react';

import { Row, Col, Divider } from 'antd';

import { EmailEditor } from 'common/components';
import AplSampleRequestDynamicContentForm from './AplSampleRequestDynamicContentForm';
import AplSampleRequestEmailForm from './AplSampleRequestEmailForm';
import AplContactEmail from './AplContactEmail';

const AplSendSampleRequestEditor = (props) => {
  const {
    dataRef,
    invalidTag,
    setInvalidTag,
    emailForm,
    currentContact,
    onChangeContactEmail,
    template,
    senderInfo,
    validateFormRef,
    requestSampleData,
    setRequestSampleData,
  } = props;

  const productData = requestSampleData?.[currentContact]?.productList;
  const { dynamicContent } = requestSampleData?.[currentContact] ?? {};

  return (
    <>
      {requestSampleData ? (
        <Row className='apl-request-sample'>
          <Col span={3} style={{ height: '100%' }}>
            <AplContactEmail
              onChangeContactEmail={onChangeContactEmail}
              currentContact={currentContact}
              requestSampleData={requestSampleData}
            />
          </Col>
          <Divider type='vertical' style={{ height: '100%' }} />
          <Col span={6} style={{ height: '100%' }}>
            <AplSampleRequestDynamicContentForm
              ref={validateFormRef}
              invalidTag={invalidTag}
              contactEmail={currentContact}
              dynamicContent={dynamicContent}
              setRequestSampleData={setRequestSampleData}
              requestSampleData={requestSampleData}
            />
          </Col>
          <Divider type='vertical' style={{ height: '100%' }} />
          <Col style={{ height: '100%', maxWidth: 'calc(63% - 34px)' }}>
            <AplSampleRequestEmailForm
              form={emailForm}
              contactEmail={currentContact}
              setRequestSampleData={setRequestSampleData}
            />
            <div className='apl-request-sample__email-content '>
              <EmailEditor
                contactEmail={currentContact}
                dynamicContent={dynamicContent}
                requestSampleData={requestSampleData}
                setRequestSampleData={setRequestSampleData}
                productData={productData}
                setInvalidTag={setInvalidTag}
                invalidTag={invalidTag}
                dataRef={dataRef}
                senderInfo={senderInfo}
                template={template}
              />
            </div>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default AplSendSampleRequestEditor;
